import { HTTP_CONTROL, beginControlsUpdate, finishControlsUpdate, isCanceledRequest } from '@/http'

const state = {
  controls: {},
  controlsPreloader: true,
  controlsUpdating: false,
}

const mutations = {
  setControls: function(state, value) {
    state.controls = { ...value }
  },
  setControlsPreloader: function(state, value) {
    state.controlsPreloader = value
  },
  setControlsUpdating: function(state, value) {
    state.controlsUpdating = value
  },
}

const actions = {
  updateControls(context) {
    context.commit('setControlsUpdating', true)
    context.commit('setControlsPreloader', true)
    let requestGroup = beginControlsUpdate()
    let controls = {}
    return HTTP_CONTROL.get('/api/v1/arc')
      .then(response => {
        if (response.status === 200) {
          controls = { ...response.data }
          context.commit('setControls', controls)
          context.commit('setControlsPreloader', false)
        }
      })
      .catch(e => {
        if (!isCanceledRequest(e)) {
          this.errorMessage = e
          this.dispatch('errorProcess', e)
        }
      })
      .finally(() => {
        if (finishControlsUpdate(requestGroup)) {
          context.commit('setControlsPreloader', false)
          context.commit('setControlsUpdating', false)
        }
      })
  },
}

const getters = {
  getControls(state) {
    return state.controls
  },
  getControlsPreloader(state) {
    return state.controlsPreloader
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
